import React from 'react'
import { Builder, withChildren } from '@builder.io/react'
import { ColWrapper, ColHeader } from 'components/footerBarV2/components/tailwindWrappers'
import Container from 'components/Container'
import { SleepLinearGradient } from 'components/sleepLinearGradient'
import { isMobile } from 'react-device-detect'
import { nightSkyBkgDsktp, nightSkyBkgMobile } from 'resources/images'
import { Link } from 'react-router-dom'
import { Collapsible } from 'components/footerBarV2/components'
import NewsLetterSignup from '../resourceCenter/components/NewsLetterSignup'

type FooterContactUsSectionProps = {
  header: string;
  body: string;
}

const FooterContactUsSection = ( props: FooterContactUsSectionProps ) => {
  return (
    <div className="hidden lg:block">
      <ColWrapper>
        <ColHeader>{props.header}</ColHeader>

        <div
          className="[&_p]:text-white lg:[&_p]:text-base [&_p]:text-sm [&_p]:font-light [&_a]:text-lightBlue [&_a]:cursor-pointer [&_a]:hover:underline"
          dangerouslySetInnerHTML={{
            __html: props.body
          }}
        />
      </ColWrapper>
    </div>

  )
}

type MobileCustomFooterDisplayProps = {
  contactUsText: string;
  socialMediaList: {
    icon: string;
    link: string;
    height: number;
    width: number;
    alt: string;
  }[];
}

const MobileCustomFooterDisplay = ( props: MobileCustomFooterDisplayProps ) => {
  return (
    <div className="block lg:hidden">
      <div className="flex flex-col gap-8 mt-16">
        <ul className="flex flex-row items-center justify-between flex-wrap">
          {props?.socialMediaList?.map( ( option, i ) => {
            return (
              <Link key={i} to={option.link}>
                <img
                  src={option.icon}
                  height={option.height}
                  width={option.width}
                  alt={option.alt}
                  className="m-2"
                />
              </Link>

            )
          })}
        </ul>
        <div className="px-8 pt-3 mx-auto w-full max-w-md">
          <NewsLetterSignup
            newsLetterSignupText={`Enter your email to subscribe to our monthly newsletter:`}
            textClassName="text-white font-family--inter text-base pb-2" newsLetterSignupHeader={null}
          />
        </div>
        <div
          className="[&_p]:text-white text-center lg:[&_p]:text-base [&_p]:text-sm [&_p]:font-light [&_a]:text-lightBlue [&_a]:cursor-pointer [&_a]:hover:underline"
          dangerouslySetInnerHTML={{
            __html: props.contactUsText
          }}
        />
      </div>

    </div>
  )
}

Builder.registerComponent( MobileCustomFooterDisplay, {
  name: `MobileCustomFooterDisplay`,
  inputs: [
    {
      name: `contactUsText`,
      type: `richText`,
      required: true
    },
    {
      name: `socialMediaList`,
      type: `list`,
      required: true,
      subFields: [
        {
          name: `icon`,
          type: `file`,
          allowedFileTypes: [ `svg`, `jpeg`, `png`, `webp` ],
          required: true
        },
        {
          name: `link`,
          type: `text`
        },
        {
          name: `height`,
          type: `number`,
          required: true
        },
        {
          name: `width`,
          type: `number`,
          required: true
        },
        {
          name: `alt`,
          type: `text`,
          required: true
        }
      ]
    }
  ]
})

Builder.registerComponent( FooterContactUsSection, {
  name: `FooterContactUsSection`,
  inputs: [
    {
      name: `header`,
      type: `text`,
      required: true
    },
    {
      name: `body`,
      type: `richText`,
      required: true
    }
  ]
})

type FooterLinkSectionProps = {
  header: string;
  linkList: {
    linkText: string;
    linkUrl: string;
  }[];
}

const FooterLinkSection = ( props: FooterLinkSectionProps ) => {

  return (
    <>
      <div className="hidden lg:block">
        <ColWrapper>
          <ColHeader>{props.header}</ColHeader>

          <div className="p-0 m-0 flex gap-2 items-start max-w-fit text-left justify-start md:flex-col">
            {props?.linkList?.map( ( link, i ) => {
              return (
                <Link key={i} to={link.linkUrl} className="text-white text-sm lg:text-base">{link.linkText}</Link>
              )
            })}
          </div>
        </ColWrapper>
      </div>
      <div className="block lg:hidden">
        <Collapsible
          panelHeader={props.header}
        >
          <div className="p-0 m-0 flex gap-2 items-start max-w-fit text-left justify-start flex-col pt-0 pb-[11px] pl-12">
            {props?.linkList?.map( ( link, i ) => {
              return (
                <Link key={i} to={link.linkUrl} className="text-white text-sm lg:text-base">{link.linkText}</Link>
              )
            })}
          </div>
        </Collapsible>
      </div>
    </>

  )

}

Builder.registerComponent( FooterLinkSection, {
  name: `FooterLinkSection`,
  inputs: [
    {
      name: `header`,
      type: `text`,
      required: true
    },
    {
      name: `linkList`,
      type: `list`,
      required: true,
      subFields: [
        {
          name: `linkText`,
          type: `text`,
          required: true
        },
        {
          name: `linkUrl`,
          type: `text`,
          required: true
        }
      ]
    }
  ]
})

type FooterPaymentOptionsSectionProps = {
  header: string;
  paymentOptionsList: {
    icon: string;
    height: number;
    width: number;
    alt: string;
  }[];
  paymentServicesList: {
    icon: string;
    height: number;
    width: number;
    alt: string;
  }[]
}

const FooterPaymentOptionsSection = ( props: FooterPaymentOptionsSectionProps ) => {
  return (
    <>
      <div className="hidden lg:block">
        <ColWrapper>
          <ColHeader>{props.header}</ColHeader>

          <ul className="flex flex-row items-center justify-center max-w-60 flex-wrap">
            {props?.paymentOptionsList?.map( ( option, i ) => {
              return (
                <img
                  key={i}
                  src={option.icon}
                  height={option.height}
                  width={option.width}
                  alt={option.alt}
                  className="m-2"
                />
              )
            })}

          </ul>
          <div className="w-full border-b-2 border-white" />
          <ul className="flex flex-row items-center justify-center max-w-60 flex-wrap">
            {props?.paymentServicesList?.map( ( service, i ) => {
              return (
                <img
                  key={i}
                  src={service.icon}
                  height={service.height}
                  width={service.width}
                  alt={service.alt}
                  className="m-2"
                />
              )
            })}

          </ul>
        </ColWrapper>
      </div>
      <div className="block lg:hidden">
        <Collapsible
          panelHeader={props.header}
        >
          <ul className="flex flex-row items-center justify-center max-w-60 flex-wrap">
            {props?.paymentOptionsList?.map( ( option, i ) => {
              return (
                <img
                  key={i}
                  src={option.icon}
                  height={option.height}
                  width={option.width}
                  alt={option.alt}
                  className="m-2"
                />
              )
            })}

          </ul>
          <ul className="flex flex-row items-center justify-center max-w-60 flex-wrap">
            {props?.paymentServicesList?.map( ( service, i ) => {
              return (
                <img
                  key={i}
                  src={service.icon}
                  height={service.height}
                  width={service.width}
                  alt={service.alt}
                  className="m-2"
                />
              )
            })}

          </ul>
        </Collapsible>
      </div>
    </>

  )
}

Builder.registerComponent( FooterPaymentOptionsSection, {
  name: `FooterPaymentOptionsSection`,
  canHaveChildren: true,
  inputs: [
    {
      name: `header`,
      type: `text`,
      required: true
    },
    {
      name: `paymentOptionsList`,
      type: `list`,
      required: true,
      subFields: [
        {
          name: `icon`,
          type: `file`,
          allowedFileTypes: [ `svg`, `jpeg`, `png`, `webp` ],
          required: true
        },
        {
          name: `height`,
          type: `number`,
          required: true
        },
        {
          name: `width`,
          type: `number`,
          required: true
        },
        {
          name: `alt`,
          type: `text`,
          required: true
        }
      ]
    },
    {
      name: `paymentServicesList`,
      type: `list`,
      required: true,
      subFields: [
        {
          name: `icon`,
          type: `file`,
          allowedFileTypes: [ `svg`, `jpeg`, `png`, `webp` ],
          required: true
        },
        {
          name: `height`,
          type: `number`,
          required: true
        },
        {
          name: `width`,
          type: `number`,
          required: true
        },
        {
          name: `alt`,
          type: `text`,
          required: true
        }
      ]
    }
  ]
})

type FooterSocialMediaSectionProps = {
  header: string;
  displayNewsLetterSignup: boolean;
  socialMediaList: {
    icon: string;
    link: string;
    height: number;
    width: number;
    alt: string;
  }[];
}


const FooterSocialMediaSection = ( props: FooterSocialMediaSectionProps ) => {
  return (
    <div className="hidden lg:block">
      <ColWrapper>
        <ColHeader>{props.header}</ColHeader>

        <ul className="flex flex-row items-center justify-between flex-wrap">
          {props?.socialMediaList?.map( ( option, i ) => {
            return (
              <Link key={i} to={option.link}>
                <img
                  src={option.icon}
                  height={option.height}
                  width={option.width}
                  alt={option.alt}
                  className="m-2"
                />
              </Link>

            )
          })}
        </ul>
        {
          props.displayNewsLetterSignup &&
        <div className=" pr-8 pt-3 w-full max-w-md hidden lg:block">
          <NewsLetterSignup
            newsLetterSignupText={`Enter your email to subscribe to our monthly newsletter:`}
            textClassName="text-white font-family--inter text-base pb-2" newsLetterSignupHeader={null}
          />
        </div>
        }
      </ColWrapper>
    </div>
  )


}

Builder.registerComponent( FooterSocialMediaSection, {
  name: `FooterSocialMediaSection`,
  canHaveChildren: true,
  inputs: [
    {
      name: `header`,
      type: `text`,
      required: true
    },
    {
      name: `displayNewsLetterSignup`,
      type: `boolean`,
      defaultValue: true
    },
    {
      name: `socialMediaList`,
      type: `list`,
      required: true,
      subFields: [
        {
          name: `icon`,
          type: `file`,
          allowedFileTypes: [ `svg`, `jpeg`, `png`, `webp` ],
          required: true
        },
        {
          name: `link`,
          type: `text`
        },
        {
          name: `height`,
          type: `number`,
          required: true
        },
        {
          name: `width`,
          type: `number`,
          required: true
        },
        {
          name: `alt`,
          type: `text`,
          required: true
        }
      ]
    }
  ]
})


const Footer = withChildren( ( props : { children: any }) => {
  return <footer className="relative font-light">
    {/* DESKTOP */}
    <div
      className="bg-aeroflowNavy bg-no-repeat bg-center bg-cover lg-wide:pt-5 hidden lg-wide:block pb-16"
      style={{
        backgroundImage: `url(${nightSkyBkgDsktp})`
      }}
    >
      <Container>
        { props.children }

      </Container>
    </div>

    {/* MOBILE */}
    <div
      className="md:block lg-wide:hidden pb-8 text-white bg-aeroflowNavy bg-no-repeat bg-center bg-cover"
      style={{
        backgroundImage: `url(${nightSkyBkgMobile})`
      }}
    >
      <div className="flex flex-col justify-start cursor-pointer pt-6">
        { props.children }
      </div>
    </div>
    <SleepLinearGradient height={isMobile ? 34 : 60} />
  </footer>
})

Builder.registerComponent( Footer, {
  name: `FooterContainer`
})



export default Footer